import React from "react"
import logo from '../../assets/img/logo/logo.webp'

class SpinnerComponent extends React.Component {
    render() {
        return (
            <div className="fallback-spinner d-flex align-items-center justify-content-center m-auto vh-100">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="loader">
                        <img src={logo} width={250}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default SpinnerComponent